import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { Traslado, TrasladosRespSchema } from '../data/schemas/traslado.schema';
import { Plant } from '../data/schemas/session.schema';

/** Planta activa, cosecha (obligatoria para acotar el WS) y lote buscado. */
export interface TrasladoFiltro {
  contexto: Pick<Plant, 'companyCode' | 'plantCode'>;
  cosecha: number;
  lote?: string;
}

/** Traslados a curado. */
export abstract class TrasladoDataService {
  abstract traslados(filtro: TrasladoFiltro): Observable<Traslado[]>;
}

/** Implementación real: `GET /seed-backoffice/traslado`, validado con Zod y sin fallback. */
@Injectable()
export class TrasladoApiService extends TrasladoDataService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/seed-backoffice/traslado`;

  traslados({ contexto, cosecha, lote }: TrasladoFiltro): Observable<Traslado[]> {
    let params = new HttpParams()
      .set('Empresa_Codigo', contexto.companyCode)
      .set('Planta_Codigo', contexto.plantCode)
      .set('PLote_Cosecha', cosecha);
    if (lote) params = params.set('PLote_Codigo', lote);
    return this.http.get<unknown>(this.url, { params }).pipe(map((res) => TrasladosRespSchema.parse(res)));
  }
}
